/** @jsxRuntime classic */ /** @jsx createElement */ import { createElement } from '@fluentui/react-jsx-runtime';
import { assertSlots } from '@fluentui/react-utilities';
import { FieldContextProvider, getFieldControlProps } from '../../contexts/index';
/**
 * Render the final JSX of Field
 */ export const renderField_unstable = (state, contextValues)=>{
    assertSlots(state);
    let { children  } = state;
    if (typeof children === 'function') {
        children = children(getFieldControlProps(contextValues.field) || {});
    }
    return /*#__PURE__*/ createElement(FieldContextProvider, {
        value: contextValues === null || contextValues === void 0 ? void 0 : contextValues.field
    }, /*#__PURE__*/ createElement(state.root, null, state.label && /*#__PURE__*/ createElement(state.label, null), children, state.validationMessage && /*#__PURE__*/ createElement(state.validationMessage, null, state.validationMessageIcon && /*#__PURE__*/ createElement(state.validationMessageIcon, null), state.validationMessage.children), state.hint && /*#__PURE__*/ createElement(state.hint, null)));
};
